import api from './api';

const specialEventsService = {
  // CRUD de eventos especiais
  getAll: async (params = {}) => {
    const response = await api.get('/special-events', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/special-events/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/special-events', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/special-events/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/special-events/${id}`);
    return response.data;
  },

  // Clona um evento copiando apenas o time de ataque (PTs 1-13, sem buff rotativo nem suporte)
  clone: async (id, data = {}) => {
    const response = await api.post(`/special-events/${id}/clone`, data);
    return response.data;
  },

  // Participantes
  getParticipants: async (eventId) => {
    const response = await api.get(`/special-events/${eventId}/participants`);
    return response.data;
  },

  addParticipant: async (eventId, data) => {
    const response = await api.post(`/special-events/${eventId}/participants`, data);
    return response.data;
  },

  bulkImportParticipants: async (eventId, participants) => {
    const response = await api.post(`/special-events/${eventId}/participants/bulk-import`, {
      participants
    });
    return response.data;
  },

  updateParticipant: async (eventId, participantId, data) => {
    const response = await api.put(`/special-events/${eventId}/participants/${participantId}`, data);
    return response.data;
  },

  removeParticipant: async (eventId, participantId) => {
    const response = await api.delete(`/special-events/${eventId}/participants/${participantId}`);
    return response.data;
  },

  toggleBuffStatus: async (eventId, participantId) => {
    const response = await api.patch(`/special-events/${eventId}/participants/${participantId}/toggle-buff`);
    return response.data;
  },

  importParticipantsFromSpreadsheet: async (eventId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/special-events/${eventId}/participants/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  downloadParticipantsTemplate: () => {
    // Cria um link temporário para download
    const link = document.createElement('a');
    link.href = `${api.defaults.baseURL}/special-events/template/participants`;
    link.download = 'template_participantes.csv';
    link.click();
  },

  downloadPilotsCsv: (eventId) => {
    // Cria um link temporário para download
    const link = document.createElement('a');
    link.href = `${api.defaults.baseURL}/special-events/${eventId}/export/pilots`;
    link.download = 'pilotos.csv';
    link.click();
  },

  // Grupos
  generateParties: async (eventId) => {
    const response = await api.post(`/special-events/${eventId}/parties/generate`);
    return response.data;
  },

  saveParties: async (eventId, parties) => {
    const response = await api.post(`/special-events/${eventId}/parties`, { parties });
    return response.data;
  },

  getParties: async (eventId) => {
    const response = await api.get(`/special-events/${eventId}/parties`);
    return response.data;
  },

  // Exportação
  exportParties: async (eventId) => {
    const response = await api.get(`/special-events/${eventId}/export/parties`);
    return response.data;
  },

  exportBuffRotation: async (eventId) => {
    const response = await api.get(`/special-events/${eventId}/export/buff-rotation`);
    return response.data;
  },

  exportAttackTeams: async (eventId) => {
    const response = await api.get(`/special-events/${eventId}/export/attack-teams`);
    return response.data;
  },

  // Importar de evento regular
  importFromEvent: async (specialEventId, eventId) => {
    const response = await api.post(`/special-events/${specialEventId}/participants/import-from-event`, { eventId });
    return response.data;
  },

  // Personagens emprestados (admin only - via special event)
  getLentCharacters: async (specialEventId) => {
    const response = await api.get(`/special-events/${specialEventId}/lent-characters`);
    return response.data;
  },

  // Dream Team
  dreamTeamPreview: async (classCounts) => {
    const response = await api.post('/special-events/dream-team/preview', { classCounts });
    return response.data;
  },

  dreamTeamCreate: async (payload) => {
    const response = await api.post('/special-events/dream-team/create', payload);
    return response.data;
  },

  // Relatório de participação nos últimos 4 BC
  bcParticipationReport: async () => {
    const response = await api.get('/special-events/reports/bc-participation');
    return response.data;
  },
};

export default specialEventsService;
